module.exports = __webpack_public_path__ + "img/sale-outline.b18bb21.svg";